// extracted by mini-css-extract-plugin
export default {"body__body":"MainPage_body__body__fRSbf","summary__summary":"MainPage_summary__summary__Kuj7O"};